import styled from 'styled-components';
import colors from '../../../../styles/colors';

const FeaturesListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
`;

const LabeledList = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

const FeaturesTitle = styled.div`
  color: ${({ $color }) => $color || colors.base.beta};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 11px;
  margin-bottom: 2px;
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const Feature = styled.li`
  font-size: 12px;

  &:before {
    content: "${({ $adornment }) => ($adornment ? `${$adornment} ` : '•')}";
  }
`;

export {
  FeaturesListWrapper,
  LabeledList,
  FeaturesTitle,
  List,
  Feature,
};
